import React from "react";
import {
  Button,
  FunctionField,
  ReferenceField,
  ShowProps,
  TextField,
} from "react-admin";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { GetParam } from "utils/tools";
import EditIcon from "@material-ui/icons/Edit";
import StatusField from "../../components/StatusField";
import CustomBooleanField from "../../components/CustomBooleanField";
import CustomLabeled from "../../components/layout/CustomLabeled";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
    padding: "8px 16px",
  },
});

const Summary = (props: ShowProps) => {
  const param = GetParam();
  const classes = useStyles();

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6">Student Detail</Typography>
          <Button
            className={classes.summaryButton}
            onClick={() =>
              props.history.push(
                `/students/${props.id}${
                  param.get("parentId")
                    ? `?parentId=${param.get("parentId")}`
                    : ""
                }`
              )
            }
            label="Edit"
          >
            <EditIcon />
          </Button>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomLabeled name="Id">
                <TextField source="id" emptyText="-" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={12}>
              <CustomLabeled name="Name">
                <FunctionField
                  render={(record: any) =>
                    `${record.firstName} ${record.lastName}`
                  }
                />
              </CustomLabeled>
            </Grid>
            <Grid item xs={12}>
              <CustomLabeled name="Date of Birth">
                <CustomDateField source="dateOfBirth" emptyText="-" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={12}>
              <CustomLabeled name="Gender">
                <TextField source="gender" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={12}>
              <CustomLabeled name="Medical Condition">
                <TextField source="medicalCondition" emptyText="-" />
              </CustomLabeled>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={2} style={{ borderLeft: "1px solid #ccc" }}>
            <Grid item xs={12}>
              <CustomLabeled name="Registered at">
                <CustomDateField source="createdAt" emptyText="-" isDateTime />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Last 3 Digits Of Nric/Fin/Passport + Alphabet E.G. (123a)">
                <TextField source="uniqueCode" emptyText="-" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Status">
                <StatusField source="status" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <CustomLabeled name="Updated On">
                <CustomDateField source="updatedAt" emptyText="-" isDateTime />
              </CustomLabeled>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4} style={{ borderLeft: "1px solid #ccc" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomLabeled name="External id">
                <TextField source="externalId" emptyText="-" />
              </CustomLabeled>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            School Details
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <CustomLabeled name="School">
            <ReferenceField
              source="schoolId"
              reference="schools"
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={2}>
          <CustomLabeled name="Level">
            <ReferenceField
              source="levelId"
              reference="levels"
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item xs={2}>
          <CustomLabeled name="Class">
            <ReferenceField
              source="levelGroupId"
              reference="levelGroups"
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={6}>
          <CustomLabeled name="Mac Address">
            <TextField source="macAddress" emptyText="-" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Parent Details
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <CustomLabeled name="Id">
            <TextField source="parent.id" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Name">
            <ReferenceField
              source="parent.id"
              reference="parents"
              link="show"
              emptyText="-"
            >
              <FunctionField
                render={(record: any) =>
                  `${record.firstName} ${record.lastName}`
                }
              />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Mobile">
            <TextField source="parent.mobile" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Drop Off Authorization</Typography>
        </Grid>
        <Grid item xs={6}>
          <CustomLabeled name="Need guardian for Drop Off?">
            <CustomBooleanField
              source="dropOffAuth"
              textForTrueValue="Yes"
              textForFalseValue="No"
            />
          </CustomLabeled>
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
